/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 15/01/2021
 */

import * as SessionUtils from '@/core/session_utils.js'

const createFiscalContactRequest = () => {
    return {
        session_token: SessionUtils.getGuestUserToken(),
        invited: SessionUtils.isGuestUser(),
        datos_solicitante: null
    }
}

export default createFiscalContactRequest;